import type { CUID, RatingProfileConfig } from "@esgt/types"

export function isKpiDisabled(ratingProfileConfig: RatingProfileConfig, kpiId: CUID) {
  // Explicitly checking false, as the default (no .enabled property) is to be enabled
  return ratingProfileConfig.kpis?.[kpiId]?.enabled === false
}
